import ProxyBase from '../../ProxyBase';
import ServiceProxyConfig from '../../../../configs/ServiceProxyConfig';

class CoveredWarrantProxy extends ProxyBase {
  getCoveredWarrants(data, source) {
    return this.get('GetCoveredWarrants', data, source);
  }

  getCoveredWarrantWatchlist(data) {
    return this.get('GetCWWatchList', data);
  }
}

const coveredWarrantProxy = new CoveredWarrantProxy(
  ServiceProxyConfig.Market.WatchList.ServiceUrl,
);
export default coveredWarrantProxy;
